/**
 * @enum {string}
 */
export const TriggerType = {
    USER: 'user_trigger',
    AUTO: 'system_trigger',
    BLOCKED: 'blocked_action'
};
